import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { State, SortBy, FilterBy } from './types';

export const getInitialState = (): State => ({
  templates: {},
  currentTemplateId: '',
  searchTerm: '',
  sortBy: SortBy.DateAscending,
  filterBy: FilterBy.AllTemplates,
  isLoading: false,
  currentPage: 1,
  templatesPerPage: 25,
  templatesCount: 0,
  isEmailTemplateLoading: false,
  registrationEmail: null,
  currentIntegrationTemplate: null,
  isIntegrationTemplateLoading: false,
  isIntegrationTemplateUpdating: false,
  isTemplateNotificationsLoading: false,
  templateNotifications: [],
  isTemplateWebhooksLoading: false,
  templateWebhooks: [],
  templateSourceFields: [],
  isTemplateSourceFieldLoading: false,
  templateFieldMappings: {},
  prevTemplateFieldMappings: {},
  templateFieldMappingRowError: {},
  isSaveTemplateFieldMappingLoading: {}
});

const state: State = getInitialState();

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
